{
  "CONFIRMATION__PAGE__TITLE": "Bevestiging",
  "DOCUMENTS__ACCESS_EXPIRES_IN_X_DAYS": "Toegang verloopt over {{days}} dag(en)",
  "DOCUMENTS__DOWNLOAD_ALL": "Alles downloaden",
  "DOCUMENTS__EXPIRED__DESCRIPTION": "De documenten die u probeert te bekijken, zijn niet meer beschikbaar. Vraag uw contactpersoon om ze opnieuw te verzenden.",
  "DOCUMENTS__EXPIRED__TITLE": "Document(en) niet meer beschikbaar",
  "DOCUMENTS__OVERVIEW__PAGE__TITLE": "Overzicht",
  "DOCUMENTS__PAGE__TITLE": "Documenten",
  "DOCUMENTS__TITLE": "Documenten",
  "DOWNLOAD": "Downloaden",
  "FORMS__ERROR__MIN_LENGTH": "Vul minimaal {{minlength}} tekens in",
  "FORMS__ERROR__REQUIRED": "Vereist",
  "LOGIN__CODE": "Code",
  "LOGIN__DESCRIPTION": "We hebben een beveiligingscode bezorgd via het opgegeven telefoonnummer. Voer de code in om de verificatie te voltooien.",
  "LOGIN__PAGE__TITLE": "Aanmelden",
  "LOGIN__RESEND_CODE": "Code opnieuw verzenden",
  "LOGIN__RESEND_COOLDOWN": "Gelieve nog {{seconds}} seconden te wachten voordat u opnieuw probeert",
  "LOGIN__SUBMIT": "Documenten bekijken",
  "LOGIN__TITLE": "Voer de beveiligingscode in",
  "LOGIN_FAILED__TOO_MANY_REQUESTS": "Gelieve even te wachten voordat u opnieuw probeert.",
  "LOGIN_FAILED__TOO_MANY_REQUESTS__TITLE": "Te veel verificatiepogingen",
  "LOGIN_FAILED__UNAUTHORIZED": "Toegang geweigerd. Controleer of uw code correct is ingevuld.",
  "LOGOUT": "Afmelden",
  "NO_PREVIEW": "Geen voorbeeld",
  "PAGE_NOT_FOUND": "Pagina niet gevonden",
  "UNKNOWN_ERROR__TEXT": "Als het probleem zich blijft voordoen, neem dan contact op met de verzender van het document.",
  "UNKNOWN_ERROR__TITLE": "Onbekende fout",
  "VERIFICATION__BUTTON": "Start verificatie",
  "VERIFICATION__DESCRIPTION": "Om de documenten te bekijken, vragen we u om uw identiteit te verifiëren via onderstaand telefoonnummer. U ontvangt een eenmalige code per sms of via een telefonische oproep. Voer deze code in om de verificatie te voltooien.",
  "VERIFICATION__ERROR__DESCRIPTION": "Als het probleem zich blijft voordoen, neem dan contact op met de verzender van het document.",
  "VERIFICATION__ERROR__TITLE": "Er ging iets mis.",
  "VERIFICATION__PAGE__TITLE": "Verificatie",
  "VERIFICATION__TITLE": "Er werd een document met u gedeeld."
}
